module.exports = __webpack_public_path__ + "img/img15.2ff3b0f0.png";